var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoSavedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 8C13.875 4.89317 11.3568 2.375 8.25 2.375C5.14317 2.375 2.625 4.89317 2.625 8C2.625 11.1062 5.14317 13.625 8.25 13.625C11.3568 13.625 13.875 11.1062 13.875 8Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 8C2.625 11.1062 5.14317 13.625 8.25 13.625C11.3568 13.625 13.875 11.1062 13.875 8C13.875 4.89317 11.3568 2.375 8.25 2.375C5.14317 2.375 2.625 4.89317 2.625 8Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25356 10.3082V7.621M8.25 5.72141V5.68188",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSavedList);
export default __webpack_public_path__ + "static/media/info-saved-list.816aec9b7aa697f305c26977d7dc8ff4.svg";
export { ForwardRef as ReactComponent };